import { render, staticRenderFns } from "./TranslationKeys.vue?vue&type=template&id=c275f1d6"
import script from "./TranslationKeys.vue?vue&type=script&lang=js"
export * from "./TranslationKeys.vue?vue&type=script&lang=js"
import style0 from "./TranslationKeys.vue?vue&type=style&index=0&id=c275f1d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports